






import { DrivewealthWizardStep } from "@/shared/types";
import {
  Vue,
  Component,
  Prop,
} from "@/shared/vuepack";
import { useDrivewealthWizardStore } from "@/shared/store/drivewealthWizard";

@Component({
  components: {}
})
export default class WizardProgress extends Vue {
  @Prop({ required: true })
  step: DrivewealthWizardStep;

  drivewealthWizard = useDrivewealthWizardStore();

  get stepNumber () {
    return this.drivewealthWizard.wizardStepNumber(this.step);
  }

}
